import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await register(form.username, form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur lors de l'inscription");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @keyframes floatBubble {
          0%, 100% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-20px) scale(1.05); }
        }
      `}</style>

      <div style={{
        minHeight: '100vh', background: '#EBF4FF',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '20px', position: 'relative', overflow: 'hidden'
      }}>
        {/* Bulles */}
        <div style={{ position: 'absolute', width: '320px', height: '320px', borderRadius: '50%', background: 'rgba(99,179,237,0.1)', top: '-80px', right: '-80px', animation: 'floatBubble 8s ease-in-out infinite', pointerEvents: 'none' }}></div>
        <div style={{ position: 'absolute', width: '240px', height: '240px', borderRadius: '50%', background: 'rgba(43,108,176,0.07)', bottom: '-60px', left: '-60px', animation: 'floatBubble 10s ease-in-out 1.5s infinite', pointerEvents: 'none' }}></div>
        <div style={{ position: 'absolute', width: '100px', height: '100px', borderRadius: '50%', background: 'rgba(99,179,237,0.12)', top: '15%', left: '8%', animation: 'floatBubble 6s ease-in-out 0.5s infinite', pointerEvents: 'none' }}></div>
        <div style={{ position: 'absolute', width: '60px', height: '60px', borderRadius: '50%', background: 'rgba(43,108,176,0.08)', bottom: '20%', right: '10%', animation: 'floatBubble 7s ease-in-out 2s infinite', pointerEvents: 'none' }}></div>
        <div style={{ position: 'absolute', width: '140px', height: '140px', borderRadius: '50%', background: 'rgba(99,179,237,0.08)', top: '50%', right: '15%', animation: 'floatBubble 9s ease-in-out 1s infinite', pointerEvents: 'none' }}></div>

        {/* Card */}
        <div className="fade-up" style={{
          background: '#fff', borderRadius: '24px',
          padding: '48px 40px', width: '100%', maxWidth: '420px',
          border: '1px solid var(--blue-border)',
          boxShadow: '0 20px 60px rgba(43,108,176,0.12)',
          position: 'relative', zIndex: 2
        }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <Link to="/" style={{ fontSize: '26px', fontWeight: 800, color: 'var(--blue)', letterSpacing: '-0.5px' }}>
              Agora
            </Link>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: 'var(--dark)', margin: '16px 0 6px' }}>
              Rejoins Agora
            </h1>
            <p style={{ fontSize: '14px', color: 'var(--muted)' }}>
              Crée ton compte et trouve ta tribu.
            </p>
          </div>

          {error && (
            <div style={{
              background: '#FFF5F5', color: '#E53E3E',
              padding: '12px 16px', borderRadius: '12px',
              marginBottom: '20px', fontSize: '14px',
              border: '1px solid #FED7D7'
            }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>
                Nom d'utilisateur
              </label>
              <input
                type="text" placeholder="ton_username" required
                value={form.username}
                onChange={e => setForm({ ...form, username: e.target.value })}
                style={{
                  width: '100%', padding: '13px 16px',
                  border: '1.5px solid var(--blue-border)', borderRadius: '12px',
                  fontSize: '14px', outline: 'none', transition: 'border-color .2s',
                  background: '#FAFCFF'
                }}
                onFocus={e => e.target.style.borderColor = 'var(--blue)'}
                onBlur={e => e.target.style.borderColor = 'var(--blue-border)'}
              />
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>
                Email
              </label>
              <input
                type="email" placeholder="ton@email.com" required
                value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                style={{
                  width: '100%', padding: '13px 16px',
                  border: '1.5px solid var(--blue-border)', borderRadius: '12px',
                  fontSize: '14px', outline: 'none', transition: 'border-color .2s',
                  background: '#FAFCFF'
                }}
                onFocus={e => e.target.style.borderColor = 'var(--blue)'}
                onBlur={e => e.target.style.borderColor = 'var(--blue-border)'}
              />
            </div>
            <div style={{ marginBottom: '28px' }}>
              <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text)', display: 'block', marginBottom: '6px' }}>
                Mot de passe
              </label>
              <input
                type="password" placeholder="••••••••" required
                value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                style={{
                  width: '100%', padding: '13px 16px',
                  border: '1.5px solid var(--blue-border)', borderRadius: '12px',
                  fontSize: '14px', outline: 'none', transition: 'border-color .2s',
                  background: '#FAFCFF'
                }}
                onFocus={e => e.target.style.borderColor = 'var(--blue)'}
                onBlur={e => e.target.style.borderColor = 'var(--blue-border)'}
              />
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', background: 'var(--blue)', color: '#fff',
              border: 'none', padding: '14px', borderRadius: '28px',
              fontSize: '15px', fontWeight: 600, cursor: 'pointer',
              boxShadow: '0 4px 16px rgba(43,108,176,0.3)',
              transition: 'all .2s'
            }}
              onMouseEnter={e => e.target.style.transform = 'translateY(-1px)'}
              onMouseLeave={e => e.target.style.transform = 'translateY(0)'}
            >
              {loading ? 'Inscription...' : 'Créer mon compte →'}
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '24px', fontSize: '14px', color: 'var(--muted)' }}>
            Déjà un compte ?{' '}
            <Link to="/login" style={{ color: 'var(--blue)', fontWeight: 600 }}>
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
